import React from 'react';
import { Modal } from 'antd';
import { FormattedMessage } from 'react-intl';

const ConfirmationModal = ({ isModalOpen, onYesClick, onCancel, title, description, yesText, noText, danger = true }) => {
  return (
    <Modal
      open={isModalOpen}
      onCancel={onCancel}
      closable={false}
      footer={null}
      width={400}
      centered
      styles={{
        content: {
          padding: 0,
          borderRadius: 20,
          overflow: 'hidden',
          boxShadow: '0 32px 80px rgba(15,15,25,0.2), 0 8px 32px rgba(99,102,241,0.12), 0 1px 0 rgba(255,255,255,0.9) inset',
          border: '1px solid rgba(99,102,241,0.14)',
        },
        mask: {
          backdropFilter: 'blur(6px)',
          background: 'rgba(15,15,25,0.4)',
        },
      }}
    >
      {/* Icon + header */}
      <div className="flex flex-col items-center px-7 pt-8 pb-5" style={{ background: 'white' }}>
        {/* Icon circle */}
        <div
          className="w-12 h-12 rounded-2xl flex items-center justify-center mb-4 flex-shrink-0"
          style={danger
            ? { background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.15)' }
            : { background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.15)' }
          }
        >
          {danger ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="#ef4444" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 11v4M14 11v4" stroke="#ef4444" strokeWidth="1.75" strokeLinecap="round"/>
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="#6366f1" strokeWidth="1.75"/>
              <path d="M12 8v4M12 16v.5" stroke="#6366f1" strokeWidth="1.75" strokeLinecap="round"/>
            </svg>
          )}
        </div>

        {/* Title */}
        <h3 className="text-base font-semibold text-center mb-2" style={{ color: 'rgba(15,15,25,0.88)' }}>
          {title}
        </h3>

        {/* Description */}
        {description && (
          <p className="text-sm text-center leading-relaxed" style={{ color: 'rgba(15,15,25,0.52)', maxWidth: 300 }}>
            {description}
          </p>
        )}
      </div>

      {/* Divider */}
      <div style={{ height: 1, background: 'rgba(99,102,241,0.08)' }} />

      {/* Footer */}
      <div className="flex items-center gap-2.5 px-6 py-4" style={{ background: 'rgba(99,102,241,0.015)' }}>
        <button
          onClick={onCancel}
          className="flex-1 text-sm font-medium py-2 rounded-xl transition-colors"
          style={{ color: 'rgba(15,15,25,0.55)', background: 'rgba(15,15,25,0.05)', border: '1px solid rgba(15,15,25,0.09)' }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(15,15,25,0.09)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(15,15,25,0.05)'}
        >
          {noText || <FormattedMessage id="NO" defaultMessage="Cancel" />}
        </button>
        <button
          onClick={onYesClick}
          className="flex-1 text-sm font-semibold py-2 rounded-xl text-white transition-all"
          style={danger
            ? { background: 'linear-gradient(135deg, #f87171, #ef4444)', boxShadow: '0 4px 14px rgba(239,68,68,0.35)', border: '1px solid rgba(239,68,68,0.3)' }
            : { background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', boxShadow: '0 4px 14px rgba(99,102,241,0.35)', border: '1px solid rgba(99,102,241,0.3)' }
          }
          onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          {yesText || <FormattedMessage id="YES" defaultMessage="Confirm" />}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
